import React from 'react';
import { connect } from 'react-redux';
import { Link, Route } from 'react-router-dom';
// import has from 'lodash/has';
import Arrow from './Arrow';
import {
  getCurrentUserGroup,
  getCurrentUserCity,
  getCurrentUserFirstName,
  getCurrentUserLastName,
  getCurrentUserEmail,
  getQuizSections,
  getAnswers,
  getQuestions,
  totalNumberQuestions,
  currentUserNumberQuestionsAnswered,
  currentUserNumberQuestionsAnsweredIncorrectly,
  currentUserNumberQuestionsAnsweredCorrectly,
} from '../selectors';
// import QuizSection from './QuizSection';
import '../styles/Quiz.css';


const Quiz = ({
  showModal = true,
  closeModal,
  quizSections,
  numCorrect,
  numIncorrect,
  totalQuestions,
  numberOfQuestionsAnswered,
  currentUserFirstName,
  currentUserLastName,
  currentUserCity,
  currentUserGroup,
  currentUserEmail,
}) => (
  <div className="mw-100 mw7-ns center">
    {quizSections.map((section, sectionIndex) => (
      <ul key={section.title}>
        <Link to={`/quiz/${sectionIndex}/${section.questions[0]}`}>
          <li className="flex items-start justify-between lh-title pv3 ph3 bg-white mv1">
            <div>
              <h1 className="f5 ma0">{section.title}</h1>
              <span className="f7 ttu tracked">
                {section.numAnswered === 10 ? (
                  <span className="correct-color">
                    <i className="material-icons-xs">check_circle</i>
Complete
                  </span>
                ) : (
                  <span className="moon-gray">
                    {section.numAnswered}
                    {' '}
                        of 10 Answered
                  </span>
                )}
              </span>
            </div>
            <Arrow />
          </li>
        </Link>
      </ul>
    ))}
    <div className="QuizResults bg-white tc pb3">
      <div className="mb3">
        <h1 className="f4 pt4 ph3 pb0 mb0 lh-solid">Score</h1>
        <span className="f7 ttu tracked moon-gray">
          {numberOfQuestionsAnswered}
          {' '}
          of 60 Answered
        </span>
      </div>
      <div className="mb3 f7">
        <div className="Button-xs correct flex items-center w-40 w-20-ns b tc lh-solid center mb3">
          <i className="material-icons-small">check_circle</i>
          <span className="b">
            {numCorrect}
            {' '}
Correct
          </span>
        </div>
        <div className="Button-xs incorrect flex items-center w-40 w-20-ns b tc lh-solid center mb3 ">
          <i className="material-icons-small">cancel</i>
          <span className="b">
            {numIncorrect}
            {' '}
Incorrect
          </span>
        </div>
      </div>
      {(numberOfQuestionsAnswered === totalQuestions) && (
        <div className="pt4 ph3 mb3 center">
          <a target="_blank" href={`//surveys.autoevents.io/subaru/2018/forester-event-survey/?firstname=${currentUserFirstName}&lastname=${currentUserLastName}&email=${currentUserEmail}&city=${currentUserCity}&group=${currentUserGroup}`}>
            <button className="Button w-100 center b" style={{maxWidth: '20rem'}}>Tell us about your experience</button>
          </a>
        </div>
      )}
    </div>
    <div>
    {(numberOfQuestionsAnswered === totalQuestions) && (
        <Route
          path="/quiz/survey"
          exact
          render={() => (
            <div className="Modal end">
              <div className="Modal-content">
                <Link className="Modal-close" to="/quiz">&times;</Link>
                <h1 className="f2-ns f3 lh-title mb3">Great work! You're almost done.</h1>
                <div className="QuizResults bg-white tc pb3">
                  <div className="mb3">
                    <a target="_blank" href={`//surveys.autoevents.io/subaru/2018/forester-event-survey/?firstname=${currentUserFirstName}&lastname=${currentUserLastName}&email=${currentUserEmail}&city=${currentUserCity}&group=${currentUserGroup}`}>
                      <button className="Button w-100 ph2 center b">Tell us about your experience</button>
                    </a>
                  </div>
                  <div className="mb1">
                    <h1 className="f5 ph3 lh-solid moon-gray">Score</h1>
                  </div>
                  <div className="mb3 f7">
                    <div className="Button-xs correct flex items-center w-70 w-40-ns b tc lh-solid center mb3">
                      <i className="material-icons-small">check_circle</i>
                      <span className="b">
                        {numCorrect}
                        {' '}
                Correct
                      </span>
                    </div>
                    <div className="Button-xs incorrect flex items-center w-70 w-40-ns b tc lh-solid center mb3 ">
                      <i className="material-icons-small">cancel</i>
                      <span className="b">
                        {numIncorrect}
                        {' '}
                Incorrect
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        />
      )}
    </div>
  </div>
);


function mapStateToProps(state, ownProps) {
  return {
    currentUserGroup: getCurrentUserGroup(state, ownProps),
    currentUserCity: getCurrentUserCity(state, ownProps),
    currentUserFirstName: getCurrentUserFirstName(state, ownProps),
    currentUserLastName: getCurrentUserLastName(state, ownProps),
    currentUserEmail: getCurrentUserEmail(state, ownProps),
    quizSections: getQuizSections(state),
    questions: getQuestions(state),
    answers: getAnswers(state),
    totalQuestions: totalNumberQuestions(state),
    numberOfQuestionsAnswered: currentUserNumberQuestionsAnswered(state, ownProps),
    numIncorrect: currentUserNumberQuestionsAnsweredIncorrectly(state),
    numCorrect: currentUserNumberQuestionsAnsweredCorrectly(state),
  };
}

export default connect(mapStateToProps)(Quiz);



// WEBPACK FOOTER //
// ./src/components/Quiz.js